import { render, staticRenderFns } from "./my-number.vue?vue&type=template&id=5f9f994f&"
import script from "./my-number.vue?vue&type=script&lang=js&"
export * from "./my-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports